(() => {
  const binde = (sre) => {
    if (sre.__sre) return;
    sre.__sre = true;
    const ids = (sre.dataset.sre || '').split(',').map((s) => s.trim()).filter(Boolean);
    const ziele = ids.map((id) => document.querySelector(`.shopify-section[id$="__${CSS.escape(id)}"]`)).filter(Boolean);
    if (ziele.length < 2) return;
    const liste = document.createElement('div');
    liste.className = 'sre__reiter';
    liste.setAttribute('role', 'tablist');
    const links = document.createElement('div');
    links.className = 'sre__links';
    const knoepfe = ziele.map((z, i) => {
      const h = z.querySelector('.kt--kapitel h1, .kt--kapitel h2, .kt--kapitel h3, h2');
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sre__knopf';
      b.setAttribute('role', 'tab');
      b.id = `${z.id}-reiter`;
      b.setAttribute('aria-controls', z.id);
      b.textContent = h ? h.textContent.trim() : ids[i];
      z.setAttribute('role', 'tabpanel');
      z.setAttribute('aria-labelledby', b.id);
      z.classList.add('sre-ziel');
      const kopf = h && h.closest('.group-block, .ese__kopf, .svs__aussage');
      const a = kopf && kopf.querySelector('a[href]:not(.kt a)');
      b.__link = a ? a.cloneNode(true) : null;
      liste.append(b);
      return b;
    });
    const zeige = (n, fokus) => {
      knoepfe.forEach((b, i) => {
        const an = i === n;
        b.setAttribute('aria-selected', an);
        b.tabIndex = an ? 0 : -1;
        ziele[i].hidden = !an;
      });
      links.replaceChildren(...(knoepfe[n].__link ? [knoepfe[n].__link] : []));
      if (fokus) knoepfe[n].focus();
    };
    knoepfe.forEach((b, i) => b.addEventListener('click', () => zeige(i)));
    liste.addEventListener('keydown', (e) => {
      const i = knoepfe.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); zeige((i + 1) % knoepfe.length, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); zeige((i - 1 + knoepfe.length) % knoepfe.length, true); }
    });
    sre.replaceChildren(liste, links);
    sre.classList.add('sre--an');
    document.documentElement.classList.add('sre-aktiv');
    zeige(0);
    document.addEventListener('shopify:section:select', (e) => {
      const i = ziele.findIndex((z) => z.contains(e.target) || z === e.target);
      if (i >= 0) zeige(i);
    });
  };
  const alle = () => document.querySelectorAll('[data-sre]').forEach(binde);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
